export default "https://legacy.eskolare.com/images/aws-ed-start-member.png";